module.exports = __webpack_public_path__ + "img/cargo-wagon-door-vertical-top-mask.71af5425.png";